import React from 'react';
import {useListContext} from 'react-admin';
import {useFormContext} from 'react-hook-form';

import {Button} from '../../../components';

import {defaultFiltersValues} from './ListFilterForm';

export const ClearFiltersButton = () => {
    const {displayedFilters, setFilters} = useListContext();
    const {setValue} = useFormContext();

    const onClearFilters = () => {
        setValue('budgetType', defaultFiltersValues.budgetType);
        setValue('q', defaultFiltersValues.q);
        setValue('statuses', defaultFiltersValues.statuses);
        setValue('startDate', defaultFiltersValues.startDate);

        setFilters(defaultFiltersValues, displayedFilters);
    };

    return (
        <Button
            className="secondary"
            color="primary"
            disableElevation
            variant="contained"
            onClick={onClearFilters}
        >
            Clear filters
        </Button>
    );
};